import { arrayOf, bool, shape, string } from 'prop-types';

export const profile = shape({
  id: string.isRequired,
  name: string.isRequired,
  email: string.isRequired,
  groups: arrayOf(string).isRequired,
  isExternal: bool.isRequired,
});
